import axios from "axios"

export default{
    async Info(data){
        const response = await axios.post(`/api/currencyrates/info`,data)
        return response
    },
    async GetInfoByDate(data){
        const response = await axios.post(`/api/currencyrates/getinformationbydate`,data)
        return response
    },
    async GetTodayCurrencyRateByNetsisCurrencyCode(data){
        const response = await axios.get(`/api/currencyrates/get/todaycurrencyratebynetsiscurrencytype/${data}`)
        return response
    }
}